import React from "react";
import { PaymentProcessingDashboard as PaymentProcessingDashboardComponent } from "@/components/PaymentProcessingDashboard";

export default function PaymentProcessingDashboard() {
  return <PaymentProcessingDashboardComponent />;
}
